import axiosInstance, { getNewCancelToken } from '@/services/_AxiosInstance';

export default {
  // Daftar report beda-beda per asset, jadi jangan di-hardcode.
  // Asset tanpa device dibalas 404 "data Devices not found!" -> biarin nge-throw,
  // caller yang nerjemahin jadi "no reports available".
  async getReportList(massId) {
    const { data } = await axiosInstance.get('/reports/report/list', {
      params: { devcMassId: massId },
      cancelToken: getNewCancelToken(),
    });

    // 412 (no access) beda kasus dari "asset ini emang belum ada reportnya" -
    // throw biar caller bisa nampilin pesan yang bener, bukan diem-diem kosong.
    if (data.status?.errorCode === 412) {
      throw Object.assign(new Error(data.status.message || 'No Access'), { errorCode: 412 });
    }

    return data.data || [];
  },

  async getReports(start, end, massId, reportType = []) {
    const params = {
      devcMassId: massId,
      aggregatedUnit: 'HOUR',
      aggregatedLength: 1,
      reports: reportType,
    };
    const interval = parseInt(end) - parseInt(start);
    if (interval <= 86400) params.dataTables = true;

    const response = await axiosInstance.get(`/reports/report/print/period/${start}/${end}`, {
      params,
      responseType: 'blob',
      cancelToken: getNewCancelToken(),
    });

    // responseType blob bikin error body ikut lolos sebagai blob, bukan masuk catch.
    // Nggak bisa cek content-type: API balikin error JSON dengan header text/html.
    // File beneran selalu bawa content-disposition, response error nggak.
    const disposition = response.headers['content-disposition'] || '';
    const match = disposition.match(/filename="?([^";]+)"?/);
    if (!match) {
      // Coba baca blob-nya sebagai JSON buat bedain 412 (no access) dari kegagalan lain.
      let errorCode = null;
      try {
        errorCode = JSON.parse(await response.data.text())?.status?.errorCode;
      } catch (e) {
        // bukan JSON, biarin errorCode null
      }
      if (errorCode === 412) {
        throw Object.assign(new Error('No Access'), { errorCode: 412 });
      }
      throw new Error('Report generation failed');
    }

    return {
      blob: response.data,
      filename: match[1],
    };
  },
};
